import Rails from "@rails/ujs"
// Replace with a stimulus controller
window.slaSetter = function() {
  let project_prefix = document.getElementById("project_project_prefix_id");
  let project_client = document.getElementById("project_client_id");
  let template_id = document.querySelector("#project_template_id");
  let project_sla1 = document.getElementById("project_date_due");
  let project_sla2 = document.getElementById("project_second_sla_due");
  let project_corp_ref = document.querySelector("#project_corporate_ref");

  function updateSla(client, prefix) {
    let url = ''
    if(template_id){
      url = `/utilities/project_sla?client_id=${project_client.value}&project_prefix_id=${project_prefix.value}&template_id=${template_id.value}`
    }
    else{
      url = `/utilities/project_sla?client_id=${project_client.value}&project_prefix_id=${project_prefix.value}`
    }
    Rails.ajax({
      type: "GET",
      url: url,
      dataType: 'json',
      success: function(data) { 
        project_sla1.value=data["sla1"]
        project_sla2.value=data["sla2"]
      }
    });
  }

  function updateCorpRef(prefix) { 
    Rails.ajax({
      type: "GET",
      url: `/utilities/project_prefix?id=${prefix.value}`,
      dataType: 'json',
      success: function(data) { 
        if (data["user_supplies_ref"]) {
          project_corp_ref.value= ""
          project_corp_ref.disabled=false
        }
        else{
          project_corp_ref.value= "auto"
          project_corp_ref.disabled=true
        }
      }
    });
  }
  project_prefix.addEventListener("change", function(e) { 
    updateSla(project_client, project_prefix)
    updateCorpRef(project_prefix)
  })


  project_client.addEventListener("select2Chosen", function(e) { 
    updateSla(project_client, project_prefix)
  });
  
  updateSla(project_client, project_prefix)
  updateCorpRef(project_prefix)
}
